export interface EmailAddressParts {
  localPart: string;
  domainParts: string[];
}

export const personalEmail: EmailAddressParts = {
  localPart: "timo",
  domainParts: ["rothdeutsch", "de"],
};

export const vecuraEmail: EmailAddressParts = {
  localPart: "hello",
  domainParts: ["vecura", "io"],
};

export function formatEmailAddress(address: EmailAddressParts): string {
  return `${address.localPart}@${address.domainParts.join(".")}`;
}

export function createMailtoHref(address: EmailAddressParts): string {
  return `mailto:${formatEmailAddress(address)}`;
}
